import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../services/component.service';
import { ShopModalComponent } from './components/modal';
import { ShopService } from '../../services/shop.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
/**
 * Header Component
 */
let WebShopComponent = class WebShopComponent {
    constructor(httpClient, router, compService, shopService, sanitizer, themeService, activated, googleAnalyticsService) {
        this.httpClient = httpClient;
        this.router = router;
        this.compService = compService;
        this.shopService = shopService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.activated = activated;
        this.googleAnalyticsService = googleAnalyticsService;
        this.products = [];
        this.localProducts = [];
        this.secondColor = '';
        this.backColor = '';
        this.successColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    ngOnInit() {
        localStorage.removeItem('checkoutData');
        localStorage.removeItem('paymentData');
        this.httpClient.get('shop/getproducts').subscribe((products) => {
            this.products = products;
            this.activated.params.subscribe((params) => {
                const id = params['id'];
                if (id && typeof this.products !== undefined) {
                    let available = 0;
                    for (let i = 0; i < this.products.length; i++) {
                        if (this.products[i].id === parseInt(id)) {
                            available = this.products[i].available;
                            break;
                        }
                    }
                    this.openProduct(id, available);
                }
                else {
                    this.router.navigateByUrl('/shop');
                }
            });
        }, (error) => {
            this.router.navigateByUrl('/');
        });
        this.localProducts = this.shopService.getProducts();
    }
    openProduct(item_id, available) {
        if (available > 0) {
            this.compService.openModal(ShopModalComponent, {
                id: item_id
            }, (success) => {
                this.localProducts = this.shopService.getProducts();
            }, (error) => {
                this.router.navigateByUrl('/shop');
            });
        }
        else {
            this.router.navigateByUrl('/shop');
        }
    }
    googleAnalyticsClick(category) {
        let array = [];
        array.push({
            'event': 'shopDetailsCTAclick',
            productName: category
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
};
WebShopComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: ComponentService },
    { type: ShopService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: ActivatedRoute },
    { type: GoogleAnalyticsService }
];
WebShopComponent = __decorate([
    Component({
        selector: 'ecd-webshop',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./webshop.component.html")).default
    })
], WebShopComponent);
export { WebShopComponent };
